export enum DqTagEnvHost {
  prod = "https://dmp.decentriq.com/submit",
  // TODO: ask for proper debug API url
  debug = "",
}

export enum DqTagEventApi {
  witness = "witness/v1",
  identify = "identify/v1",
  profile = "profile/v1",
  log = "log/v1",
}

export const TCF_VENDOR_ID = 1449;

export const TCF_CONSENT_IDS = [1, 2, 3, 4, 7];

export const DQ_ID_STORAGE_KEY = "dqTag:dqId";
